import { ELinkSeparatingLine, ESupportedLinkTypes, supportedLinkTypes } from './AddKinescopeVideo.config';
import { TVideoValues } from './AddKinescopeVideo.types';

export const checkIsKinescopeUrlValid = (link: string): boolean =>
    !!link?.startsWith('https') && supportedLinkTypes.some((format) => link?.includes(format));

export const validateVideo = (values: TVideoValues): string | undefined =>
    checkIsKinescopeUrlValid(values?.videoData?.url) ? undefined : 'error';
